<style scoped>

</style>
<template>
  <div>
    <div class="line text-center">
      <div
        class="search-input margin-r"
        style="margin-bottom:10px"
      >
        <i-input
          v-model="params.search"
          placeholder="请输入搜索关键字"
          @on-enter="doSearch"
        />
      </div>
      <Ajaxbtn
        ref="searchBtn"
        :url="$util.api.query_expense_register"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
      />
    </div>

    <Table
      :columns="columns"
      :data="expense_registers"
      :loading="loading"
    />

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
  </div>
</template>
<script route="/invoice/register/expense_bx">
  import { BX_CATEGORY_HASH } from './../libs/fields'
  import {mapGetters} from "vuex";
  export default {
    /* router_info_start */
    router_info: '/invoice/register/expense_bx',
    /* router_info_end */

    data() {
      return {
        loading: false,
        expense_registers: [],
        params: {
          search: '',
          per_page: 20,
          page: 1,
          is_finish: 0,
          payment_type: 0,
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        columns: [
          {
            title: '申请人',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              const row = params.row;
              if (row.customer_id) {
                return h('CustomerPoptip', {
                  props: {
                    customer_id: row.customer_id
                  }
                }, [h('span', {
                  'class': {
                    'link': true
                  }
                }, row.customer.account)]);
              }
              return h('span', row.customer.account);
            }
          },
          {
            key: 'id',
            title: '登记序列号',
            align: 'center',
            minWidth: 100,
          },
          {
            title: '团队',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('span', row.customer.team);
            }
          },
          {
            key: 'office',
            title: '工作地点',
            minWidth: 150,
            align: 'center',
          },
          {
            title: '报销类型',
            align: 'center',
            minWidth:100,
            key: 'bx_type'
          },
          {
            title: '报销类目',
            align: 'center',
            minWidth:160,
            render: (h, {row = {}} = {}) => {
              const bx_category_arr = row.bx_category.split(',')
              return <div>
                        {bx_category_arr.map(item => <p>
                         {BX_CATEGORY_HASH[item]}
                        </p>)}
                        </div>
            }
          },
          {
            key: 'bx_amount',
            title: '报销金额',
            align: 'center',
            minWidth:100,
          },
          {
            key: 'invoice_buyer',
            title: '公司抬头',
            minWidth:100,
            align: 'center',
          },
          {
            key: 'invoice_amount',
            minWidth:100,
            title: '发票金额',
          },
          {
            key: 'invoice_count',
            title: '发票数量',
            minWidth:100,
            align: 'center',
          },
          {
            key: 'remark',
            minWidth:100,
            title: '报销备注',
          },
          {
            key: 'advance_remark',
            minWidth:100,
            title: '冲预支备注',
          },
          {
            key: 'comment',
            minWidth:100,
            title: '意见',
          },
          {
            title: '登记时间',
            minWidth:100,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatTime(row.created_at));
            }
          },

        ]
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      ...mapGetters({
        companies_hash: 'async/companies_hash',
        teams_hash: 'async/root_teams_hash',
      }),
    },
    created() {
      //
    },
    mounted() {
      this.doSearch();
    },
    methods: {
      getLinkTitle(expense_register) {
        const register_type = expense_register.register_type
        let str = ''
        switch (register_type) {
        case 1:
          str = '付款单号'
          break;
        case 2:
        case 3:
          str = '合同号'
          break;
        default:
          str = '备注'
          break;
        }
        return str
      },
      doSearch() {
        this.$refs.searchBtn.doAjax();
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.loading = true;
        this.$refs.searchBtn.doAjax(true);
      },
      beforeSearch() {
        this.params.page = 1;
        this.loading = true;
      },
      handleData(data) {
        this.loading = false;
        this.expense_registers = data.expense_registers;
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleFail(e) {
        this.loading = false;
        this.$Modal.error({title: '提示', content: e.message});
      },
    }
  }
</script>
